import React, { useLayoutEffect } from 'react'
import { Suspense, lazy, useEffect, useState } from 'react'
import { Button } from '../../common'
import BannerNotFound from '../../../assets/Image-not-found.png'
import { WpPost } from '../../../interfaces'
import { isMobile } from '../../../common_functions'

const SkeletonLoading = lazy(() => import('../../../components/common/SkeletonLoading'))
const CardBlogPrimary = lazy(() => import('../../Cards/CardBlogPrimary'))
const CardBlogSecondary = lazy(() => import('../../Cards/CardBlogSecondary'))

interface Props {
  seeMore: boolean
  readMore?: boolean
  isCarousel?: boolean
  maxSize?: number
}

export default function SectionBlogHome({ seeMore, readMore, isCarousel = false, maxSize }: Props) {
  const [posts, setPosts] = useState<WpPost[]>([])
  const [selectedIndexPost, setSelectedIndexPost] = useState<number>(0)

  let touchStartX: number = 0
  let touchEndX: number = 0

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX = e.changedTouches[0].screenX
  }

  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX = e.changedTouches[0].screenX
  }

  const handleTouchEnd = () => {
    if (touchStartX - touchEndX > 50) {
      // Swiped left
      if (selectedIndexPost < posts.length - 1) {
        // Certifique-se de não ultrapassar o comprimento de posts
        setSelectedIndexPost(selectedIndexPost + 1)
      }else{
        setSelectedIndexPost(0)
      }
    }

    if (touchStartX - touchEndX < -50) {
      // Swiped right
      if (selectedIndexPost > 0) {
        // Certifique-se de não ir abaixo de 0
        setSelectedIndexPost(selectedIndexPost - 1)
      }else{
        if(posts) setSelectedIndexPost(posts?.length - 1)
      }
    }
  }

  const fetchData = async () => {
    const perPage = 100
    let page = 1
    const response = await fetch(
      `https://deportasabertasglemo.com.br/wp-json/wp/v2/posts?order=desc&per_page=${perPage}`
    )
    var listAux: WpPost[] = await response.json()
    listAux = listAux.filter((x) => !x.link.includes('/en/'))
    setPosts(listAux.slice(0, 3))
  }

  useLayoutEffect(() => {
    fetchData()
  }, [])

  return (
    <section id="sectionBlogHome" className="lg:bg-[#BFBFBF1A] lg:px-[10rem] py-10 px-5">
      <Suspense fallback={<SkeletonLoading />}>
        <>
          {readMore ? (
            <div className="mb-10">
              <h2 className="text-6xl font-bold  lg:text-[#474747]">
                <span className="overline decoration-[#F15C00] ">Leia mais </span>
                no nosso blog
              </h2>
            </div>
          ) : (
            <div>
              <h2 className="text-4xl lg:text-6xl lg:mb-10 text-[#474747] lg:text-black font-bold">
                {isMobile() ? (
                  <>
                    <span className="overline decoration-[#F15C00]">Blog do </span>
                    GlemO
                  </>
                ) : (
                  <>
                    <span className="overline decoration-[#F15C00]">Confira </span>
                    também o nosso blog
                  </>
                )}
              </h2>
              <p className="text-2xl mb-10 mt-5 lg:hidden">
                Fique por dentro de tudo o que você precisa saber para comprar seu imóvel novo!
              </p>
            </div>
          )}
        </>
      </Suspense>
      <Suspense fallback={<SkeletonLoading />}>
        <>
          {posts != undefined ? (
            <>
              {isCarousel ? (
                // <CarouselBlogHome posts={posts} />
                <>
                  {posts[selectedIndexPost] != undefined && (
                    <div
                      onTouchStart={handleTouchStart}
                      onTouchMove={handleTouchMove}
                      onTouchEnd={handleTouchEnd}
                    >
                      <CardBlogPrimary
                        category={posts[selectedIndexPost].categories[0]}
                        date={new Date(posts[selectedIndexPost].date)}
                        description={posts[selectedIndexPost].content.rendered}
                        imgUrl={
                          posts[selectedIndexPost].jetpack_featured_media_url ??
                          BannerNotFound
                        }
                        title={posts[selectedIndexPost].title.rendered}
                        link={posts[selectedIndexPost].link}
                      />
                    </div>
                  )}
                  <div className="w-full text-center mt-0 pt-4">
                    {posts.length > 0 && (
                      <>
                        {posts.map((item, index) => {
                          return (
                            <button
                              onClick={() => setSelectedIndexPost(index)}
                              className={`bullet ${
                                selectedIndexPost == index ? 'bg-[#0059FF]' : 'bg-[#00000033]'
                              } m-auto w-[8px] aspect-square mx-[5px] rounded-full`}
                            ></button>
                          )
                        })}
                      </>
                    )}
                  </div>
                  {/* <CarouselTinySliderChildren id="tinySliderBlogHome">
                    {posts?.map((item, index) => {
                      return (
                        <div key={item.id}>
                          <CardBlogPrimary
                            category={item.categories[0]}
                            date={new Date(item.date)}
                            description={item.content.rendered}
                            imgUrl={item.yoast_head_json?.og_image[0]?.url ?? BannerNotFound}
                            title={item.title.rendered}
                            link={item.link}
                          />
                        </div>
                      )
                    })}
                  </CarouselTinySliderChildren> */}
                </>
              ) : (
                <div className="lg:grid lg:grid-cols-2 gap-5">
                  <>
                    {posts.length >= 1 && (
                      <div>
                        <CardBlogPrimary
                          link={posts[0].link}
                          category={posts[0].categories[0]}
                          date={new Date(posts[0].date)}
                          description={posts[0].content.rendered}
                          imgUrl={
                          posts[0].jetpack_featured_media_url ??
                          BannerNotFound
                        }
                          title={posts[0].title.rendered}
                        />
                      </div>
                    )}
                    <div className="grid gap-5" style={{ placeSelf: 'center' }}>
                      {posts.length >= 2 && (
                        <div>
                          <CardBlogSecondary
                            category={posts[1].categories[0]}
                            date={new Date(posts[1].date)}
                            description={posts[1].content.rendered}
                            imgUrl={
                          posts[1].jetpack_featured_media_url ??
                          BannerNotFound
                        }
                            title={posts[1].title.rendered}
                            link={posts[1].link}
                          />
                        </div>
                      )}
                      {posts.length >= 3 && (
                        // <div className='h-[50%] grid m-auto' style={{placeContent: 'flex-end'}}>
                        <div>
                          <CardBlogSecondary
                            category={posts[2].categories[0]}
                            date={new Date(posts[2].date)}
                            description={posts[2].content.rendered}
                            imgUrl={
                          posts[2].jetpack_featured_media_url ??
                          BannerNotFound
                        }
                            title={posts[2].title.rendered}
                            link={posts[2].link}
                          />
                        </div>
                      )}
                    </div>
                  </>
                </div>
              )}
            </>
          ) : (
            <>
              <div
                className="border-l-4 border-orange-500 text-orange-700 p-4"
                role="alert"
                style={{ backgroundColor: 'rgba(255, 237, 213, 0.2)' }}
              >
                <p className="font-bold">Houve um erro ao carregar os cards do blog!</p>
                <p>Tente atualizar a página ou acesse o blog clicando abaixo.</p>
              </div>
            </>
          )}
        </>
      </Suspense>

      <div className="max-w-[289px] w-full m-auto mt-12">
        {seeMore ? (
          <a href={'https://deportasabertasglemo.com.br/'} target="_blank">
            <Button
              id="seeMorePublications"
              variant="primary"
              children="VER MAIS PUBLICAÇÕES"
              className="w-full"
            />
          </a>
        ) : (
          <div></div>
        )}
      </div>
    </section>
  )
}
